export const LOADING_SALESORDERS = "LOADING_SALESORDERS";
export const GET_SALESORDERS_LIST = "GET_SALESORDERS_LIST";
export const REMOVE_SALESORDERS = "REMOVE_SALESORDERS";
export const ADD_SALESORDERS = "ADD_SALESORDERS";
export const UPDATE_SALESORDERS = "UPDATE_SALESORDERS";
export const GET_SALESORDERSBYID = "GET_SALESORDERSBYID";
export const GET_PRODUCTORDER = "GET_PRODUCTORDER";
export const LOADING_PRODUCTORDER = "LOADING_PRODUCTORDER";
export const CHECK_INVENTORY = "CHECK_INVENTORY";

export const LOADING_PROFORMA_DOCUMENT = "LOADING_PROFORMA_DOCUMENT";
export const REMOVE_PROFORMA_DOCUMENT = "REMOVE_PROFORMA_DOCUMENT";
export const ADD_PROFORMA_DOCUMENT = "ADD_PROFORMA_DOCUMENT";
export const ADD_PROFORMA_MULTI_DOCUMENT = "ADD_PROFORMA_MULTI_DOCUMENT";
export const DOWNLOAD_PROFORMA_DOCUMENT = "DOWNLOAD_PROFORMA_DOCUMENT";
export const GET_PROFORMA_DOCUMENT_LIST = "GET_PROFORMA_DOCUMENT_LIST";